import { Doc } from '../../types';
import { LabelBadgeInfo } from './hooks/use-drive-label-badges';
import DriveLabelChipsCell from './drive-label-chips-cell';

interface DriveDocLabelsCellProps {
  readonly doc: Doc;
  readonly getLabelBadgeInfo: (
    labelId: string,
    choiceIds: string[]
  ) => LabelBadgeInfo;
}

export default function DriveDocLabelsCell({
  doc,
  getLabelBadgeInfo,
}: DriveDocLabelsCellProps) {
  const titles = doc.labelTitles ?? [];
  const ids = doc.labelIds ?? [];
  const choiceIdsPerLabel = doc.labelChoiceIds ?? [];

  const chips = titles.map((title, index) => {
    const labelId = ids[index] ?? '';
    const { selectedBadge, allBadges } = getLabelBadgeInfo(
      labelId,
      choiceIdsPerLabel[index] ?? []
    );
    return {
      id: `${labelId}-${index}`,
      title: selectedBadge?.text || title,
      labelTitle: title,
      backgroundColor: selectedBadge?.backgroundColor,
      foregroundColor: selectedBadge?.foregroundColor,
      allBadges,
    };
  });

  return <DriveLabelChipsCell labels={chips} />;
}
